import {Condition} from "../engine/Condition";
import {loadUTMParams} from "../../../utils/Referrer";
import {UTM_PARAM_KEYS} from "../../../Constants";
import {toArray} from "../../../../stem-core/base/Utils.js";


export interface UTMOptions {
    medium?: string | string[];
    campaign?: string | string[];
    source?: string | string[];
    term?: string | string[];
    content?: string | string[];
}

export class UTMCondition extends Condition<UTMOptions> {
    evaluate() {
        const utmParams = loadUTMParams();

        const matches = (paramKey: keyof UTMOptions) => {
            if (!this.options.hasOwnProperty(paramKey)) {
                return true; // no filter for this UTM parameter
            }
            return toArray(this.options[paramKey]).indexOf(utmParams[paramKey]) >= 0;
        };
        for (const key of UTM_PARAM_KEYS) {
            if (!matches(key)) {
                return false;
            }
        }
        return true;
    }
}
